// 앱은 #root(position:fixed)/#max-container(overflow:hidden) 구조라 window 스크롤이
// 실질적으로 막혀 있고, 실제 스크롤 주인은 PullToRefresh 의 .ptr-scroll-container
// (height:100%; overflow-y:auto) 다. App.js 는 라우트 변경 시 이 컨테이너를 0으로
// 올리지만, 같은 라우트 내 단계(state) 전환에서는 트리거되지 않으므로 직접 올린다.
//
// scrollTo 가 무시/throw 되는 환경(일부 WebView/JSDOM)을 대비해 scrollTop 직접 대입을
// 항상 함께 적용하고, WebView 레이아웃 지연을 이겨내기 위해 즉시 1회 + rAF 로 재시도한다.
function applyTopScroll(el, behavior) {
    if (!el) return;
    if (typeof el.scrollTo === "function") {
        try {
            el.scrollTo({ top: 0, left: 0, behavior });
        } catch {
            try {
                el.scrollTo(0, 0);
            } catch {
                // scrollTo 자체가 throw 되는 환경은 아래 scrollTop 대입을 최종 폴백으로 둔다.
            }
        }
    }
    try {
        el.scrollTop = 0;
    } catch {
        // 읽기 전용 등 예외 환경은 무시한다(여기까지 오면 더 할 수 있는 게 없다).
    }
}

export function scrollToTop(behavior = "auto") {
    if (typeof document === "undefined") return;

    const apply = () => {
        const ptr = document.querySelector(".ptr-scroll-container");
        if (ptr) applyTopScroll(ptr, behavior);
        if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
            try {
                window.scrollTo({ top: 0, left: 0, behavior });
            } catch {
                try {
                    window.scrollTo(0, 0);
                } catch {
                    // window.scrollTo 미지원 환경은 무시한다.
                }
            }
        }
    };

    apply();
    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(apply);
    }
}

export default scrollToTop;
